import _ from "lodash";
import { typeConsts, rdvPotentiels, motifConsts, getTypeConstFromTypeNumber, getMotifNumberFromMotifName, } from "../../cadendar-consts.js";
import { isNouveauPatient, isAncienPatient } from "./ancienPatient.js";
const checkMotifs = function (arr, motifsDuPatient) {
    return arr.reduce(function (answer, motif) {
        if (motifsDuPatient.includes(motifConsts[motif])) {
            return true;
        }
        else {
            return answer;
        }
    }, false);
};
const getTypeAndPotentielFromMotifs = function (motifs, patient) {
    "use strict";
    let potentiel, type;
    if (isNouveauPatient(patient)) {
        if (checkMotifs([
            "DKCTROU",
            "DLR",
            "ORTHO",
            "COUR",
            "RESC",
            "GENCIVE",
            "DEVIS",
            "CARIE",
            "IMPLANT",
            "BILAN",
            "DLR",
            "PROT",
        ], motifs)) {
            potentiel = rdvPotentiels.PB;
            type = typeConsts.PCONSULT;
            return { potentiel, type };
        }
        if (checkMotifs(["DET", "CTRL", "DDS"], motifs)) {
            potentiel = rdvPotentiels.PPRDV;
            type = typeConsts.PCONSULT;
            return { potentiel, type };
        }
        if (checkMotifs(["URGENCE", "TRAUMA"], motifs)) {
            potentiel = rdvPotentiels.URGENCE;
            type = typeConsts.URGENCE;
            return { potentiel, type };
        }
        //défaut pour nouveau patient
        if (!potentiel && !type) {
            potentiel = rdvPotentiels.PPRDV; //todo est-ce que c'est pertinent ?
            type = typeConsts.PCONSULT;
            return { potentiel, type };
        }
    }
    if (isAncienPatient(patient)) {
        //ctrl de routine
        if (checkMotifs(["CTRL"], motifs)) {
            potentiel = rdvPotentiels.PPRDV;
            type = typeConsts.CTRLROUT;
            return { potentiel, type };
        }
        //urgence
        if (checkMotifs(["URGENCE", "TRAUMA", "DDS"], motifs)) {
            potentiel = rdvPotentiels.URGENCE;
            type = typeConsts.URGENCE;
            return { potentiel, type };
        }
        //nouveau pb
        if (checkMotifs([
            "DKCTROU",
            "DLR",
            "COUR",
            "RESC",
            "GENCIVE",
            "DEVIS",
            "CARIE",
            "IMPLANT",
            "BILAN",
        ], motifs)) {
            potentiel = rdvPotentiels.PB;
            type = typeConsts.DIV;
            return { potentiel, type };
        }
        //séance de soins rentable ODF
        if (checkMotifs(["ORTHO"], motifs)) {
            potentiel = rdvPotentiels.HPRDV;
            type = typeConsts.ODF;
            return { potentiel, type };
        }
        //séance de soins rentable Prothèse
        if (checkMotifs(["DUREE", "PROT"], motifs)) {
            potentiel = rdvPotentiels.HPRDV;
            type = typeConsts.PROT;
            return { potentiel, type };
        }
        //séance de soins rentable Implant
        if (checkMotifs(["IMPLANT"], motifs)) {
            potentiel = rdvPotentiels.HPRDV;
            type = typeConsts.IMPLANT;
            return { potentiel, type };
        }
        //séance de soins rentable Paro
        if (checkMotifs(["PARO"], motifs)) {
            potentiel = rdvPotentiels.HPRDV;
            type = typeConsts.PARO;
            return { potentiel, type };
        }
        //séance de soins non rentable
        if (checkMotifs(["CARIE"], motifs)) {
            potentiel = rdvPotentiels.PPRDV;
            type = typeConsts.RESTAU;
            return { potentiel, type };
        }
        if (checkMotifs(["EXTRAC"], motifs)) {
            potentiel = rdvPotentiels.PPRDV;
            type = typeConsts.EXT;
            return { potentiel, type };
        }
        //blahblah
        if (checkMotifs(["BLABLA"], motifs)) {
            potentiel = rdvPotentiels.HPRDV;
            type = typeConsts.BLABLA;
            return { potentiel, type };
        }
        if (checkMotifs(["DET"], motifs)) {
            potentiel = rdvPotentiels.PPRDV;
            type = typeConsts.DET;
            return { potentiel, type };
        }
    }
    //défaut
    potentiel = rdvPotentiels.PPRDV; //todo pertinent ?
    type = typeConsts.DIV;
    return { potentiel, type };
};
const getPotentielFromType = (typeNumber) => {
    if ([
        "DET",
        "EXT",
        "CTRLROUT",
        "RESTAU",
        "EXT",
        "CTRLROUT",
        "RETPATIENT",
        "DIV",
        "PCONSULT",
    ].includes(getTypeConstFromTypeNumber(typeNumber))) {
        return rdvPotentiels.PPRDV;
    }
    if ([
        "RETPANO",
        "RETMUT",
        "PDT",
        "IMPLANT",
        "ODF",
        "PROT",
        "POSEIMPL",
        "PARO",
    ].includes(getTypeConstFromTypeNumber(typeNumber))) {
        return rdvPotentiels.HPRDV;
    }
    if (["URGENCE"].includes(getTypeConstFromTypeNumber(typeNumber))) {
        return rdvPotentiels.URGENCE;
    }
    // Attention: ce sont des motifs et pas des types !
    // if (
    //   [
    //     "DLR",
    //     "DKCTROU",
    //     "RESC",
    //     "GENCIVE",
    //     "BILAN",
    //     "DEVIS",
    //     "CARIE",
    //     "AUTRE"
    //   ].includes(getTypeConstFromTypeNumber(typeNumber))
    // ) {
    //   return rdvPotentiels.PB;
    // }
};
var getMotifFromType = function (type) {
    "use strict";
    const typesToMotifs = {
        PCONSULT: "AUTRE",
        URGENCE: "URGENCE",
        RETPANO: "BLABLA",
        RETMUT: "BLABLA",
        RESTAU: "CARIE",
        DET: "DET",
        EXT: "EXTRAC",
        BLABLA: "BLABLA",
        PARO: "PARO",
        PROT: "DUREE",
        ODF: "ORTHO",
        RETPATIENT: "AUTRE",
        CTRLROUT: "CTRL",
        POSEIMPL: "DUREE",
        PDT: "BLABLA",
        DIV: "AUTRE",
        MANQRET: "AUTRE",
        DOULEUR: "DLR",
        IMPLANT: "IMPLANT",
    };
    const typeKey = _.invert(typeConsts)[type];
    const motifKey = typesToMotifs[typeKey];
    let motifs = [];
    if (typeof motifKey === "string") {
        motifs = [motifConsts[motifKey]];
    }
    if (motifs.length === 0) {
        return [motifConsts.AUTRE];
    }
    return motifs;
};
const getTypeFromMotifNames = (motifs, patient) => {
    const motifsNumbers = motifs.map(getMotifNumberFromMotifName);
    const result = getTypeAndPotentielFromMotifs(motifsNumbers, patient);
    return result.type;
};
export { getMotifFromType, getTypeAndPotentielFromMotifs, getPotentielFromType, getTypeFromMotifNames, };
//# sourceMappingURL=typesMotifs.js.map